<template>
  <div>
    <div class="card">
      <div class="card-content">

        <h4 class="card-title">Verificación (Evolución Patrimonial)</h4>

        <div class="row" v-show="shlista">
          <div v-if="rol != 4" class="col-md-8">
            <label>Dependencia </label><br>
            <el-select clearable class="select-default" filterable name="dependencia" placeholder="Dependencia" v-model="model.dependencia_id">
              <el-option v-for="option in dependencias1" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div v-if="rol != 4" class="col-md-4 pull-left">
            <button @click="getDeclaraciones" class="btn btn-fill btn-success" :disabled="loading_bar">
              {{ loading_bar ? 'Buscando datos' : 'Buscar' }}
            </button>
          </div>
        </div>
        <br>
        <div v-show="shlista">
          <br>
          <div class="offset-md-6 col-sm-6 col-md-6 col-lg-6">
            <b-form-group label-cols-sm="3" class="mb-0">
              <b-input-group>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row mt-3 mb-4">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <v-data-table :headers="headers" :items="filtro_usuarios" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-slot:item.acciones="{ item }">
                  <div class="d-flex justify-content-center">
                    <b-button @click.prevent="historico(item)" class="btn-s edit mr-2" variant="primary" v-b-popover.hover.top="'Ver'">
                      <i class="fas fa-search"></i></b-button>
                  </div>
                </template>
                <template v-slot:item.id="{ item }">
                  <div>{{ dateFormat(item.fecha) }}</div>
                </template>
              </v-data-table>

              <v-data-table v-show="shhistorico" :headers="headers2" :items="table_list" :items-per-page="5" :search="filter" class="" :fixed-header="true">
                <template v-slot:item.anio="{ item }">
                  <div>{{ filterAnio(item.created_at) }}</div>
                </template>

                <template v-slot:item.patrimonial="{ item }">
                  <b-button class="btn-s edit mr-2" variant="primary" @click.prevent="descargar(item.id)">
                    <i class="far fa-file-pdf"></i>
                  </b-button>
                </template>

              </v-data-table>
            </div>
          </div>
        </div>


      </div>


      <div class="card-content" v-show="shhistorico">
        <button @click="regresar" class="btn btn-fill btn-success pull-right">
          Regresar
        </button>
        <br><br><br>
        <div>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-chip class="ma-2" color="primary" label>
              <v-icon left>fas fa-user</v-icon>
              {{ this.nombre }}
            </v-chip>

            <!-- <v-chip class="ma-2" color="primary" label>
              <v-icon left>fas fa-building</v-icon>
              {{ this.entidad }}
            </v-chip> -->

            <v-data-table :headers="headers2" :items="table_list" :items-per-page="5" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="historico1(item)" class="btn-s edit mr-2" variant="primary" v-b-popover.hover.top="'Ver'">
                    <i class="fas fa-search"></i>
                  </b-button>
                </div>
              </template>
              <template v-slot:item.declaracion_id="{ item }">
                <div>{{ item.Tipo_Dec }}</div>
              </template>
              <template v-slot:item.entidad="{ item }">
                <div>{{ entidad }}</div>
              </template>
              <template v-slot:item.anio="{ item }">
                <div>{{ dateFormat3(item.created_at) }}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>

      <div class="card-content" v-show="balanza">
        <button @click="regresar1" class="btn btn-fill btn-success pull-right">
          Regresar
        </button>
        <br><br><br>
        <div>
        </div>
        <template>
          <div>
            <div class="row">
              <div class="col-md-12 col-md-offset-1">
                <div class="card card-wizard" id="wizardCard">
                  <form-wizard error-color="#EB5E28" color="#1e94fd" title="Consulta general del servidor público" subtitle="">
                    <div>
                      <b-tabs content-class="mt-3">
                        <b-tab title="Generales" active>
                          <table style="width:100%">
                            <tr>
                              <td style="text-align: left;color:navy; font-weight: 900;">Nombres</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">Dependencia</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">Cargo</td>

                            </tr>
                            <tr>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.nombres }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ datos_encargo_actual.dependencia }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ datos_encargo_actual.cargo }}</td>
                            </tr>
                            <tr>
                              <td style="text-align: left;color:navy; font-weight: 900;">Correo oficial</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">Correo alternativo</td>
                            </tr>
                            <tr>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.ce_laboral }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.ce_personal }}</td>
                            </tr>
                            <tr>
                              <td style="text-align: left;color:navy; font-weight: 900;">Calle</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">No. Ext</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">No. Int</td>
                            </tr>
                            <tr>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.calle }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.numext }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.numint }}</td>
                            </tr>
                            <tr>
                              <td style="text-align: left;color:navy; font-weight: 900;">Colonia</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">Ciudad</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">Estado</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">CP</td>
                            </tr>
                            <tr>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.colonia }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.municipio }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.entidad }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.cp }}</td>
                            </tr>
                            <tr>
                              <td style="text-align: left;color:navy; font-weight: 900;">Teléfono</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">Estado civil</td>
                              <td style="text-align: left;color:navy; font-weight: 900;">CURP</td>
                            </tr>
                            <tr>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.tel_particular }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.edoCivil }}</td>
                              <td style="text-align: left;text-transform: uppercase;">{{ informacion_personal.curp }}</td>
                            </tr>
                          </table>
                        </b-tab>
                        <b-tab title="Gráfica" @click="fillData()">
                          <template>
                            <div>
                              <div class="col-md-12">
                                <div class="card card-circle-chart">
                                  <div class="card-content position-relative">
                                    <GChart type="LineChart" :data="chartData" :options="chartOptions" :resizeDebounce="850" />
                                    <!-- <div id="chartStock1" class="ct-chart"></div> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                          </template>
                        </b-tab>
                        <b-tab title="Balanza">
                          <table class="table table-striped table-hover">
                            <thead class="thead-green">
                              <tr>
                                <th width="75%">ACTIVOS</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <!-- <tr>
                                <td>Sueldos y salarios públicos</td>
                                  <div v-if="datosDeclaracion.tipo_declaracion_id == 1" v-for="sueldo in spublicos"  class="text-right">
                                    <td style="color: green;">
                                      {{sueldo.ingreso}}
                                    </td>
                                  </div>
                                  <div v-else v-for="sueldo in spublicosant"  class="text-right">
                                    <td style="color: green;">
                                      {{sueldo.ingreso}}
                                    </td>
                                  </div>
                              </tr> -->
                              <tr>
                                <td>Sueldos y salarios</td>
                                <td v-if="datosDeclaracion.tipo_declaracion_id == 1" class="text-right" style="color: green;">
                                  {{ totalingresos.total }}
                                </td>
                                <td v-else class="text-right" style="color: green;">
                                  {{ totalingresosant.total }}
                                </td>
                              </tr>
                              <tr>
                                <td>Inmuebles</td>
                                <td class="text-right" style="color: green;">{{ totalbinmuebles }}</td>
                              </tr>
                              <tr>
                                <td>Vehículos</td>
                                <td class="text-right" style="color: green;">{{ totalbmuebles }}</td>
                              </tr>
                              <tr>
                                <td>Muebles</td>
                                <td class="text-right" style="color: green;">
                                  {{ totalbmueblesnr }}
                                </td>
                              </tr>
                              <tr>
                                <td>Inversiones</td>
                                <td class="text-right" style="color: green;">
                                  {{ totalinversiones }}
                                </td>
                              </tr>
                              <tr>
                                <td>Total Activos</td>
                                <td v-if="datosDeclaracion.tipo_declaracion_id == 1" class="text-right" style="color: green;">
                                  {{ totalactivos }}
                                </td>
                                <td v-else class="text-right" style="color: green;">
                                  {{ totalactivosant }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <table class="table table-striped table-hover">
                            <thead class="thead-red">
                              <tr>
                                <th width="75%">PASIVOS</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Adeudos</td>
                                <td class="text-right" style="color: red;">
                                  {{ totalpendiente }}
                                </td>
                              </tr>
                              <tr>
                                <td>Depósito en inversiones</td>
                                <td class="text-right" style="color: red;">
                                  {{ totalmontooriginal }}
                                </td>
                              </tr>
                              <tr>
                                <td>Total Pasivos</td>
                                <td class="text-right" style="color: red;">{{ totalpasivos }}</td>
                              </tr>
                            </tbody>
                          </table>
                          <table class="table table-striped table-hover">
                            <thead class="thead-blue">
                              <tr>
                                <th width="75%">BALANCE GENERAL</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td></td>
                                <td v-if="datosDeclaracion.tipo_declaracion_id == 1" class="text-right" style="color: green;">
                                  {{ totalbalanza }}
                                </td>
                                <td v-else class="text-right">
                                  {{ totalbalanzaant }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!--<table class="balanza">
                           <!--  <tr>
                              <th></th>
                              <th>DECLARANTE</th>
                            </tr>
                            <tr>
                              <td><br>INGRESOS</td>
                            </tr>
                            <tr>
                                <td>Sueldos y salarios públicos (situación actual)</td>
                            </tr>
                            <div v-if="datosDeclaracion.tipo_declaracion_id == 1" v-for="sueldo in spublicos"  class="padd">
                              <tr >
                                <td style="color: green;">
                                  {{ sueldo.ingreso}}
                                </td>
                              </tr>
                            </div>
                            <div v-else v-for="sueldo in spublicosant"  class="padd">
                              <tr >
                                <td style="color: green;">
                                  {{ sueldo.ingreso}}
                                </td>
                              </tr>
                            </div>
                            <tr>
                                <td>Otros sueldos y salarios (situación actual)</td>
                            </tr>
                            <!-- <div v-for="sueldo in otross"  class="padd">
                              <tr >
                                <td style="color: green;">
                                  {{ sueldo.ingreso}}
                                </td>
                              </tr>
                            </div>
                            <tr>
                                <td>Total otros sueldos y salarios (situación actual)</td>
                            </tr>
                            <tr >
                                <td v-if="datosDeclaracion.tipo_declaracion_id == 1" style="color: green;">
                                  {{ totalingresos.total}}
                                </td>
                                <td v-else style="color: green;">
                                  {{ totalingresosant.total}}
                                </td>
                              </tr>
                            <tr>
                              <td><br>ACTIVOS</td>
                            </tr>
                            <tr>
                                <td>Inmuebles</td>
                            </tr>
                            <!-- <div v-for="inmuebles in binmuebles"  class="padd">
                              <tr >
                                <td style="color: green;">
                                  {{ inmuebles.padquisicion}}
                                </td>
                              </tr>
                              <tr>
                              </tr>
                            </div>
                            <td style="color: green;">
                                {{totalbinmuebles}}
                            </td>
                            <tr>
                                <td>Vehículos</td>
                            </tr>
                            <!-- <div v-for="vehiculos in bmuebles"  class="padd">
                              <tr >
                                <td style="color: green;">
                                  {{ vehiculos.padquisicion}}
                                </td>
                              </tr>
                            </div>
                             <td style="color: green;">
                                  {{ totalbmuebles}}
                                </td>
                            <tr>
                                <td>Muebles</td>
                            </tr>
                            <!-- <div v-for="bmuebles in bmueblesnr"  class="padd">
                              <tr >
                                <td style="color: green;">
                                  {{ bmuebles.padquisicion}}
                                </td>
                              </tr>
                            </div>
                            <td style="color: green;">
                               {{ totalbmueblesnr}}
                            </td>
                            <tr>
                                <td>Inversiones</td>
                            </tr>
                            <!-- <div v-for="inversion in inversiones"  class="padd">
                              <tr >
                                <td style="color: green;">
                                  {{ inversion.monto_original}}
                                </td>

                              </tr>
                            </div>
                             <td style="color: green;">
                                  {{ totalinversiones}}
                            </td>
                            <tr>
                              <td><br>PASIVOS</td>
                            </tr>
                            <tr>
                                <td>Adeudos</td>
                            </tr>
                            <!-- <div v-for="pasivo in pasivos"  class="padd">
                              <tr >
                                <td style="color: red;">
                                  {{ pasivo.pendiente}}
                                </td>
                              </tr>
                            </div>
                            <td style="color: red;">
                                  {{ totalpendiente}}
                                </td>
                            <tr>
                                <td>Depósito en inversiones</td>
                            </tr>
                            <!-- <div v-for="inversion in inversionesad"  class="padd">
                              <tr >
                                <td style="color: red;">
                                  {{ inversion.monto_original}}
                                </td>
                              </tr>
                            </div>
                            <td style="color: red;">
                              {{totalmontooriginal}}
                            </td>
                          </table>
                          -->
                        </b-tab>
                      </b-tabs>
                    </div>
                    <button slot="next" class="d-none">Siguiente</button>
                    <button slot="finish" class="d-none">Siguientes</button>
                  </form-wizard>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

    </div>
  </div>
</template>
<script>
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
import StatsCard2 from 'src/components/UIComponents/Cards/StatsCard2.vue'
import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
import chartist_tooltip from 'chartist-plugin-tooltips'
import Chartist from 'chartist'
import swal from 'sweetalert2'
import VueGoogleCharts from 'vue-google-charts'
import {
  GChart
} from 'vue-google-charts'

import {
  FormWizard,
  TabContent
} from 'vue-form-wizard'
import moment from 'moment'
import Vue from 'vue'
import {
  Table,
  TableColumn,
  Select,
  Option
} from 'element-ui'
import PPagination from 'src/components/UIComponents/Pagination.vue'

export default {
  components: {
    PPagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    FormWizard,
    TabContent,
    StatsCard,
    StatsCard2,
    ChartCard,
    CircleChartCard,
    GChart
  },
  data () {
    return {
      $Chartist: null,
      chartData: [
        ['Años', 'Activos', 'Pasivos'],
        ['2019', 0, 0]
      ],
      chartOptions: {
        chart: {
          title: 'Gráfica de evolución de ingresos y egresos'
        },
        width: '90%',
        height: 500,
        title: 'Gráfica de evolución de ingresos y egresos',
        series: {
          0: {
            color: '#68B3C8'
          },
          1: {
            color: '#7AC29A'
          }
        },
        pointSize: 8
        // pointShape: { type: 'triangle', rotation: 180 }

      },
      porcentaje: 0,
      declaraciones: '',
      obligados: '',
      model: {
        tipo_declaracion: '',
        dependencia_id: '',
        periodo: '2020'
      },
      min: 0,
      max: 0,
      rol: '',
      filter: '',
      nombre: '',
      activo: null,
      alta: '',
      baja: '',
      entidad: '',
      filter2: '',
      graf_load: '',
      datacollection: null,
      loading_bar: false,
      shhistorico: false,
      shlista: true,
      balanza: false,
      currentPage: 1,
      grafica: [],
      table_list: [],
      table_list1: [],
      ingresos: [],
      informacion_personal: [],
      encargo: {},
      bienes_inmuebles: [],
      bienes_muebles_no_registrables: [],
      bienes_muebles_registrables: [],
      pasivos_deudas: [],
      totalpendiente: [],
      datos_encargo_actual: [],
      datosDeclaracion: [],
      spublicos: [],
      spublicosant: [],
      totalingresos: [],
      totalingresosant: [],
      dato: [],
      otross: [],
      binmuebles: [],
      totalbinmuebles: [],
      bmuebles: [],
      totalbmuebles: [],
      bmueblesnr: [],
      totalbmueblesnr: [],
      inversioness: [],
      totalinversiones: [],
      pasivos: [],
      inversionesad: [],
      totalmontooriginal: [],
      totalpasivos: [],
      totalactivos: [],
      totalactivosant: [],
      totalbalanza: [],
      totalbalanzaant: [],
      perPage: 50,
      // periodos: [],
      rows: null,
      tiposDeclaracion: [{
        'id': 1,
        'tipo_declaracion': 'Inicial'
      }, {
        'id': 2,
        'tipo_declaracion': 'Anual'
      }, {
        'id': 3,
        'tipo_declaracion': 'Final'
      }],
      list_cumplimiento: [],
      expanded: [],
      singleExpand: true,
      filtro_usuarios: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      headers3: [{
        text: '',
        value: 'name',
        align: 'center',
        class: ''
      }, {
        text: 'DECLARANTE',
        value: 'calories',
        align: 'center',
        class: '',
        width: '200px'
      }, , {
        text: 'CONYUGUE',
        value: 'fat',
        align: 'center',
        class: '',
        width: '200px'
      }, {
        text: 'CORRESPONSABLES',
        value: 'carbs',
        align: 'center',
        class: '',
        width: '200px'
      }],
      desserts: [{
        name: 'Sueldos',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      },
      {
        name: 'Honorarios',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      },
      {
        name: 'Otros',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      },
      {
        name: 'Inmuebles',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      },
      {
        name: 'Muebles',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      },
      {
        name: 'Vehiculos',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      },
      {
        name: 'Iversiones',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      },
      {
        name: 'Adeudos',
        calories: '$0.00',
        fat: '$0.00',
        carbs: '$0.00'
      }
      ],
      headers2: [{
        text: 'Ver Balanza',
        align: 'left',
        sortable: false,
        value: 'acciones',
        class: '',
        width: '100px'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Tipo',
        value: 'Tipo_Dec',
        align: 'right',
        class: ''
      }, {
        text: 'Fecha de Presentación',
        value: 'anio',
        align: 'center',
        class: '',
        width: '200px'
      }],
      headers: [{
        text: 'Ver',
        align: 'center',
        sortable: false,
        value: 'acciones',
        class: ''
      },
      {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'center'
      }, {
        text: 'Dependencia',
        value: 'entidad',
        align: 'center'
      }, {
        text: 'Cargo',
        value: 'cargo',
        align: 'center'
      }
      ],

      propsToSearch: ['rfc', 'nombres'],
      tableColumns: [{
        prop: 'id',
        label: 'Dec',
        minWidth: 150,
        vif: false
      },
      {
        prop: 'rfc',
        label: 'RFC',
        minWidth: 150,
        vif: true
      },
      {
        prop: 'nombres',
        label: 'Nombre',
        minWidth: 100,
        vif: true
      }
      ]
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  methods: {
    openCity (evt, cityName) {
      // Declare all variables
      var i, tabcontent, tablinks

      // Get all elements with class="tabcontent" and hide them
      tabcontent = document.getElementsByClassName('tabcontent')
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = 'none'
      }

      // Get all elements with class="tablinks" and remove the class "active"
      tablinks = document.getElementsByClassName('tablinks')
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(' active', '')
      }

      // Show the current tab, and add an "active" class to the button that opened the tab
      document.getElementById(cityName).style.display = 'block'
      evt.currentTarget.className += ' active'
    },
    dateFormat: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    dateFormat2: function (date) {
      return moment(date, 'DD-MM-YYYY').format('DD/MM/YYYY')
    },
    dateFormat3: function (date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
    },
    checkPermissions () {
      let permiso = [1]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    getEntidad (item) {
      return JSON.parse(item.datos_encargo_actual)[0].ente.valor
    },
    getFechaPos (item) {
      return this.dateFormat2(JSON.parse(item.datos_encargo_actual)[0].fecha_posesion)
    },
    getCargo (item) {
      return JSON.parse(item.datos_encargo_actual)[0].empleo_cargo_comision
    },
    // getDependencias() {
    //   var v = this
    //   this.$http.get('cat_ente_publico').then(
    //     response => {
    //       this.dependencias = response.data.entes_publicos
    //       this.dependencias.unshift({
    //         'codigo': 'T',
    //         'id': 0,
    //         'valor': 'Todas'
    //       })
    //       this.model.dependencia_id = this.getKey('ente_publico_id')
    //     },
    //     error => {
    //       this.StepError(error)
    //     }
    //   )
    // },
    // getPeriodos () {
    //   var v = this
    //   this.$http.get('getPeriodos').then(
    //     response => {
    //       this.periodos = response.data.periodos
    //     },
    //     error => {
    //       this.StepError(error)
    //     }
    //   )
    // },
    descargaFiscal (file) {
      let obj = JSON.parse(file)
      if (obj[0]) {
        var url = ['https:' + this.$rootUrl + '/declaraciones_fiscales/' + obj[0].file]
        window.open(url, '_blank')
      } else {
        this.StepW('No tiene declaración fiscal')
      }
    },
    getDeclaraciones () {
      this.loading_bar = true
      this.filtro_usuarios = []
      this.$http.post('hdeclaraciones', this.model).then(
        response => {
          this.list_cumplimiento = []
          response.data.declarantes.forEach((value, key) => {
            this.list_cumplimiento.push({
              // 'id': value.id,
              // 'rfc': value.rfc,
              // 'nombres': value.nombres + ' ' + value.primer_apellido + ' ' + value.segundo_apellido,
              // 'entidad': value.encargo.ente.valor,
              // 'area': value.encargo.area_adscripcion,
              // 'cargo': value.encargo.empleo_cargo_comision,
              // 'activo': value.tipo_mov,
              // 'alta': value.created_at,
              // 'baja': value.encargo.fecha_termino,
              'id': value.id,
              'rfc': value.rfc,
              'nombres': value.nombre,
              'entidad': value.entidad,
              'area': value.area,
              'cargo': value.cargo,
              'activo': value.activo,
              'alta': value.alta,
              'baja': value.baja
            })
            this.loading_bar = false
          })
          this.filtro_usuarios = this.list_cumplimiento
        },
        error => {
          this.StepError(error)
        }
      )
    },

    descargar (row) {
      var params = {
        id: row.bit_id,
        ip_id: row.ip_id,
        declaracion_id: row.declaracion_id,
        publica: true
      }

      this.$http.post(this.$http.options.root + 'descargaDeclaracion', params, {
        responseType: 'arraybuffer'
      }).then(
        response => {
          this.downloadFile(response, 'Declaración')
        },
        error => {
          this.StepError(error)
        }
      )
    },
    historico (row) {
      this.shlista = false
      this.shhistorico = true
      this.balanza = false
      this.nombre = row.rfc
      this.activo = row.activo
      this.alta = this.dateFormat(row.alta)
      this.baja = this.dateFormat(row.baja)
      this.entidad = row.entidad
      this.table_list = []
      this.$http.get('historicolst/' + row.id).then(
        response => {
          this.table_list = response.data.response
          // console.log(this.table_list);
        },
        error => {
          this.Err(error)
        }
      )
    },
    historico1 (row) {
      this.shlista = false
      this.shhistorico = false
      this.balanza = true

      this.$swal({
        title: 'Alerta',
        text: 'Esta información es confidencial y tu acceso ha sido registrado por políticas de seguridad.',
        type: 'warning',
        confirmButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      })
      this.chartData = [
        ['Años', 'Activos', 'Pasivos'],
        ['2019', 0, 0]
      ]
      this.resetTableData()
      this.$http.get('generaleslst/' + row.declaracion_id).then(
        response => {
          this.datosDeclaracion = response.data.datosDeclaracion
          this.informacion_personal = response.data.dpersonales
          this.datos_encargo_actual = response.data.dencargo
          this.spublicos = response.data.spublicos
          this.spublicosant = response.data.spublicosant
          this.totalingresos = response.data.totalingresos
          this.totalingresosant = response.data.totalingresosant
          this.otross = response.data.otross
          this.binmuebles = response.data.binmuebles
          this.totalbinmuebles = response.data.totalbinmuebles
          this.bmuebles = response.data.bmuebles
          this.totalbmuebles = response.data.totalbmuebles
          this.bmueblesnr = response.data.bmueblesnr
          this.totalbmueblesnr = response.data.totalbmueblesnr
          this.inversioness = response.data.inversiones
          this.totalinversiones = response.data.totalinversiones
          this.pasivos = response.data.pasivos
          this.totalpendiente = response.data.totalpendiente
          this.inversionesad = response.data.inversionesad
          this.totalmontooriginal = response.data.totalmontooriginal
          this.totalpasivos = response.data.totalpasivos
          this.totalactivos = response.data.totalactivos
          this.totalactivosant = response.data.totalactivosant
          this.totalbalanza = response.data.totalbalanza
          this.totalbalanzaant = response.data.totalbalanzaant
          this.grafica = response.data.grafica
          this.max = response.data.max
          // console.log(this.spublicosant);
          this.fillData()
        },
        error => {
          this.Err(error)
        }
      )
    },
    resetTableData () {
      this.datosDeclaracion = []
      this.informacion_personal = []
      this.datos_encargo_actual = []
      this.spublicos = []
      this.spublicosant = []
      this.totalingresos = []
      this.totalingresosant = []
      this.otross = []
      this.binmuebles = []
      this.totalbinmuebles = []
      this.bmuebles = []
      this.totalbmuebles = []
      this.bmueblesnr = []
      this.totalbmueblesnr = []
      this.inversioness = []
      this.totalinversiones = []
      this.pasivos = []
      this.totalpendiente = []
      this.inversionesad = []
      this.totalmontooriginal = []
      this.totalpasivos = []
      this.totalactivos = []
      this.totalactivosant = []
      this.totalbalanza = []
      this.totalbalanzaant = []
      this.grafica = []
      this.max = []
    },
    regresar (row) {
      this.shlista = true
      this.shhistorico = false
      this.balanza = false
    },
    regresar1 (row) {
      this.shlista = false
      this.shhistorico = true
      this.balanza = false
    },
    fillData () {
      this.chartData = [
        ['Años', 'Activos', 'Pasivos'],
        ['2019', 0, 0]
      ]

      var datos = [
        ['Años', 'Activos', 'Pasivos']
      ]

      this.grafica.forEach(d => {
        datos.push([d.anio.toString(), d.activos, d.pasivos])
      })
      this.chartData = datos
    },
    getDatos () {
      this.$http.get('tableroGlobales').then(
        response => {
          this.faltantes = this.group1k(response.data.faltantes)
          this.declaraciones = this.group1k(response.data.declaraciones)
          this.obligados = this.group1k(response.data.declarantes)
          this.porcentaje = parseFloat((response.data.porcentaje).toString().substring(0, 5))
          this.rinicial = this.group1k(response.data.dinic)
          this.rfinal = this.group1k(response.data.dfin)
          this.ranual = this.group1k(response.data.danu)
          this.faltantesIn = this.group1k(response.data.decIni - response.data.dinic)
          this.faltantesAn = this.group1k(response.data.decAn - response.data.danu)
          this.faltantesFi = this.group1k(response.data.decFin - response.data.dfin)
          this.obligadosIn = this.group1k(response.data.decIni)
          this.obligadosAn = this.group1k(response.data.decAn)
          this.obligadosFi = this.group1k(response.data.decFin)
        },
        error => {
          this.StepError(error)
        }
      )
    },
    cumplimiento () {
      this.$router.push('/reportes/cumplimiento')
    },
    getEstadosC (index) {
      var resp = ' '
      if (this.estadosCi) {
        this.estadosCi.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor
            console.log(resp)
            return resp
          }
        })
      }
    },
    getEstados (index) {
      var resp = ' '
      if (this.estados) {
        this.estados.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_ent
            console.log(resp)
            return resp
          }
        })
      }
    },
    getCiudades (index) {
      var resp = ' '
      if (this.ciudades) {
        this.ciudades.forEach(function (item) {
          if (item.id == index) {
            resp = item.nom_mun
            console.log(resp)
            return resp
          }
        })
      }
    }

  },
  created () {
    // this.getDependencias()
    // this.getPeriodos()
    this.rol = this.getKey('role')
    this.checkPermissions()

    this.$http.get('edocivil').then(
      response => {
        this.estadosCi = response.data.estadoCivil
      },
      error => {
        this.Err(error)
        console.log(error)
      }
    )

    this.$http.get('entidadFed').then(
      response => {
        this.estados = response.data.entidadfed
      },
      error => {
        this.Err(error)
        console.log(error)
      }
    )

    this.$http.get('municipios').then(
      response => {
        this.ciudades = response.data.municipios
      },
      error => {
        this.Err(error)
        console.log(error)
      }
    )
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>
<style>
.ct-series-a .ct-line,
.ct-series-a .ct-point {
  stroke: #68B3C8;
}

.ct-series-b .ct-line,
.ct-series-b .ct-point {
  stroke: #7AC29A;
}

.chartist-tooltip {
  position: absolute !important;
  background: rgba(0, 0, 0, 0.6) !important;
  color: white !important;
  padding: 0px 10px !important;
  border-radius: 5px !important;
}

/* Style the tab */
.tab {
  overflow: hidden;
  border: 1px solid #ccc;
  background-color: #f1f1f1;
}

/* Style the buttons that are used to open the tab content */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #ddd;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: #ccc;
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-top: none;
}

.balanza {
  width: 100%;
}

td,
th {
  text-align: left;
  padding: 8px;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgb(217, 235, 235);
}

.table-hover tbody tr:hover {
  background-color: rgba(122, 114, 81, 0.7);
  color: rgb(112, 24, 78);
}

.thead-green {
  background-color: rgb(0, 99, 71);
  color: white;
  text-align: center;
}

.thead-red {
  background-color: rgb(255, 0, 0);
  color: white;
  text-align: center;
}

.thead-blue {
  background-color: #008cff;
  color: white;
  text-align: center;
}

.text-right {
  text-align: right !important;
}

.ct-chart .ct-series.stroke-green .ct-bar {
  stroke: green;
}

.ct-chart .ct-series.stroke-yellow .ct-bar {
  stroke: rgba(255, 167, 38, 0.8);
}

.ct-chart .ct-series.stroke-red .ct-bar {
  stroke: rgba(230, 20, 20, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/Verificacion.vue